import React from "react";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/Layouts/ScrollToTop";


import Toplearn from "./Toplearn";

const App = () => {
    return (
        <BrowserRouter>
            <ScrollToTop>
                <Toplearn />

            </ScrollToTop>
        </BrowserRouter>
    );
};

export default App;
